module.exports = __webpack_public_path__ + "img/document_collected.fa31f588.png";